import { getAdsConfig } from '../selectors/getAdsConfig'
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import AdsLib from '@gameday/ads/GamedayAds';

export default  () => {
    const adconf = useSelector(getAdsConfig);
    return useMemo(() => {
        AdsLib.setConf(adconf);
        return AdsLib;
    }, [adconf]);
};
